<div class="note-container">
  <div class="note-core">
    <div class="note-header">
      <span>Note</span>
    </div>
  </div>

  <mat-form-field class="example-full-width">
    <textarea
      matInput
      cdkTextareaAutosize
      #autosize="cdkTextareaAutosize"
      class="note-textarea"
      name="note"
      [(ngModel)]="order.note"
      [disabled]="!canUpdateNotes"
      placeholder="Leave a note"
    ></textarea>
  </mat-form-field>
  <div class="action-buttons">
    <md-outlined-button (click)="onCancel()">Reset</md-outlined-button>
    <md-filled-button [disabled]="!canUpdateNotes" (click)="onUpdate()"
      >Update</md-filled-button
    >
  </div>
</div>
